import React from 'react';
import styled, {keyframes} from "styled-components";

const WelcomeRealtorsLogos = () => {
    return (
        <Container>
            <h2 className="h1">برخی از مشتریان ۲نبش</h2>

            <Logos className="mt-24">
                <img src="/_img/landings/realtors_logo.jpg" className="w-100 h-100" alt="برخی از مشتریان ۲نبش"/>
            </Logos>
        </Container>
    );
};

export default React.memo(WelcomeRealtorsLogos);

// styles

const Container = styled.div`
    
    @media(max-width: ${props => props.theme.screenSmMax}) {
        padding: 0;
        width: 100%;
        overflow: hidden;
        
        h2 {
            margin-right: 24px;
        }
    }

`;

const logosAnimation = keyframes`
  0% {-webkit-transform:translateX(0);transform:translateX(0)}
  50% {
      -webkit-transform:translateX(50vw) translateX(400px);
      transform:translateX(50vw) translateX(400px)
  }
  to {-webkit-transform:translateX(0);transform:translateX(0)}
`;

const Logos = styled.div`
    width: 1139px;
    height: 366px;
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        width: 933px;
        height: 300px;
        padding-right: 24px;
        animation-name: ${logosAnimation};
        animation-duration: 30s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
        animation-play-state: running;
        overflow: hidden;
    }
`;